import React from 'react'
import PropTypes from 'prop-types'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import NavigationClose from 'material-ui/svg-icons/navigation/close'
import { withTheme } from 'styled-components'

import logo from '../../../images/logo_mysquare.svg'
import femaleAvatar from '../../../images/female.png'
import maletAvatar from '../../../images/male.png'
import { getAvatarUrl } from '../../../utils/processUrl'

import { AppBarLogo } from './styled-components'

const CustomAppBar = props => {
  const avatar =
    (props.user && getAvatarUrl(props.user.Avatar)) ||
    (props.user && props.user.Sex && maletAvatar) ||
    femaleAvatar
  return (
    <AppBar
      title={
        <AppBarLogo>
          <img onClick={props.onGoHome} src={logo} alt="MySquare Logo" />
        </AppBarLogo>
      }
      onLeftIconButtonTouchTap={
        props.showBackButton ? props.doGoBackButton : props.onMenuDrawerToggle
      }
      style={{
        position: 'fixed',
        boxShadow: 'none',
        backgroundColor: props.theme.palette.primaryColor || '#0288d1'
      }}
      iconElementLeft={
        props.showBackButton ? (
          <IconButton>
            <NavigationClose />
          </IconButton>
        ) : null
      }
      iconElementRight={
        <IconButton
          style={{ padding: 0 }}
          onClick={props.onProfileDrawerToggle}>
          {props.user && avatar && (
            <div style={{ textAlign: 'center' }}>
              <img
                alt="Avatar"
                src={avatar}
                style={{
                  objectFit: 'cover',
                  color: '#fff',
                  backgroundColor: 'none',
                  userSelect: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px',
                  borderRadius: '50%',
                  height: '40px',
                  width: '40px',
                  padding: '3px',
                  border: '1px solid #fff',
                  boxSshadow: 'rgb(0, 143, 195) 0px 0px 10px 0px'
                }}
              />
            </div>
          )}
        </IconButton>
      }
    />
  )
}

CustomAppBar.propTypes = {
  onMenuDrawerToggle: PropTypes.func,
  onProfileDrawerToggle: PropTypes.func,
  user: PropTypes.object,
  onGoHome: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  doGoBackButton: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired
}

export default withTheme(CustomAppBar)



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/components/AppBar.js